import { useCallback, useState } from 'react';
import uuid from 'react-uuid';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface InvoiceApproverItem {
  clientId: number;
  companyName: string;
  contact: string;
  isDefault: boolean;
  rowId: string;
  selected: boolean;
}

const useGetInvoiceApprovers = () => {
  const [invoiceApprovers, setInvoiceApprovers] = useState<InvoiceApproverItem[]>([]);
  const call = useCallback(async () => {
    try {
      const response = await axiosInstance.get<InvoiceApproverItem[]>('Invoice/Approvers');
      const approvers = response.data?.map((approveData, index) => ({
        ...approveData,
        rowId: uuid(),
        selected: index === 0,
      }));
      setInvoiceApprovers(approvers);
      return approvers;
    } catch (error) {
      throw new Error(error.message);
    }
  }, []);
  const { isLoading, value, execute } = useAsync(
    call,
    false,
    undefined,
    [] as InvoiceApproverItem[]
  );

  return {
    isApproversLoading: isLoading,
    invoiceApprovers,
    setInvoiceApprovers,
    getInvoiceApprovers: execute,
    orginalInvoiceApprovers: value,
  } as const;
};

export default useGetInvoiceApprovers;
